module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_02 (1).4a57dd78.png";